module.exports = __webpack_public_path__ + "img/suitHolder02.efffabf5.jpg";